<template>
	<div>
		<verify-alert v-if="leaderInfo" :is-show="isShowVerifyAlert" :managerName="leaderInfo.trueName"
			:managerPhone="leaderInfo.mobile" @onConfirmClick="onAlertConfirmClick"
			@onCancelClick="onAlertCancelClick"></verify-alert>
		<div class="edit-root">

			<!-- 左侧：基本信息 -->
			<div class="edit-panel left-panel">
				<div class="panel-title">基本信息</div>
				<div class="panel-row">
					<span class="panel-label">报告抬头：</span>
					<el-input v-model="reportTitle" class="panel-input" />
				</div>
				<div class="panel-row">
					<span class="panel-label">二级标题：</span>
					<el-input v-model="reportSubTitle" class="panel-input" />

				</div>
				<div class="panel-row">
					<span class="panel-label">新版报告配置：</span>
					<el-switch v-model="newReportSwitchEnabled" active-color="#6DA4D8" inactive-color="#DCDFE6"
						@change="onNewReportSwitchChange" />
				</div>
				


			</div>

			<!-- 中间：报告组成 -->
			<div class="edit-panel middle-panel" v-if="newReportSwitchEnabled">
				<div class="custom-divider-mt15"></div>
				<div class="panel-title">报告组成</div>

				<!-- 血氧脉率报告 -->
				<div class="panel-row">
					<span class="panel-label">血氧脉率报告：</span>
					<el-switch v-model="spo2PulseReportSwitch" active-color="#6DA4D8" inactive-color="#DCDFE6" />
				</div>
				<div class="panel-row checkbox-row">
					<span class="panel-label">模块配置：</span>
					<div class="checkbox-container">
						<el-checkbox-group v-model="spo2PulseModuleConfig" :disabled="!spo2PulseReportSwitch">
							<el-checkbox label="基本信息" />
							<el-checkbox label="血氧统计" />
							<el-checkbox label="氧减统计" />
							<el-checkbox label="血氧趋势" />
							<el-checkbox label="脉率统计" />
							<el-checkbox label="脉率趋势图" />
							<el-checkbox label="血氧监测综述" />
						</el-checkbox-group>
					</div>
				</div>
				<div class="panel-row">
					<span class="panel-label">二级标题：</span>
					<el-input v-model="spo2PulseSecondaryTitle" class="panel-input" :disabled="!spo2PulseReportSwitch" />
				</div>
				
				
				
				<!-- 睡眠结构报告 -->
				<div class="panel-row">
					<span class="panel-label">睡眠结构报告：</span>
					<el-switch v-model="sleepStructureSwitch" active-color="#6DA4D8" inactive-color="#DCDFE6" />
				</div>
				<div class="panel-row checkbox-row">
					<span class="panel-label">模块配置：</span>
					<div class="checkbox-container">
						<el-checkbox-group v-model="sleepStructureModuleConfig" :disabled="!sleepStructureSwitch">
							<el-checkbox label="基本信息" />
							<el-checkbox label="睡眠时长概况" />
							<el-checkbox label="睡眠分期图" />
							<el-checkbox label="睡眠监测综述" />
							<el-checkbox label="监测意见与建议" />
							<el-checkbox label="心率统计" />
							<el-checkbox label="HRV" />
						</el-checkbox-group>
					</div>
				</div>
				<div class="panel-row">
					<span class="panel-label">二级标题：</span>
					<el-input v-model="sleepStructureSecondaryTitle" class="panel-input" :disabled="!sleepStructureSwitch" />
				</div>


				
				
				<div class="custom-divider-mt15"></div>
			</div>


			<div class="edit-panel right-panel">


				<!-- <div class="panel-title">签字与日期</div> -->
				<div class="panel-row">
					<span class="panel-label">默认报告签名：</span>
					<el-switch v-model="sopReportSign" active-color="#6DA4D8" inactive-color="#DCDFE6" />
					<el-input v-model="sopReportSignValue" class="signature-input" />
				</div>
				<div class="panel-row">
					<span class="panel-label">默认签名日期：</span>
					<el-switch v-model="sopReportSignDate" active-color="#6DA4D8" inactive-color="#DCDFE6" />
				</div>
				<div class="panel-row panel-logo-upload">
					<input-unit class="edit-input" iconKey="睡眠初筛报告Logo" :initialIconURL="reportLogo" inputType="noTitle"
						@onUploadSucceed="onReportLogoUploadSucceed" />
				</div>

			</div>
		</div>
		<div class="btn-container">
			<button class="btn-cancel" @click="onCancelClick">取消</button>
			<button class="btn-save" @click="onSaveClick">保存</button>
		</div>
	</div>

</template>

<script>
import BorderInput from "@c/common/border-input.vue";
import InputUnit from "@c/setting/organization-configuration/edit/input-unit.vue";
import VerifyAlert from "@c/setting/verify-alert/verify-alert.vue";
export default {
	components: {
		BorderInput,
		InputUnit,
		VerifyAlert
	},
	props: {
		model: Object,
		newReportSwitchEnabled: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			sopReportSign: false,
			sopReportSignDate: false,
			sopReportSignValue: "",
			reportTitle: "",
			reportSubTitle: "",
			reportLogo: "",
			
			sleepStructureSwitch: false,
			sleepStructureModuleConfig: [],
			spo2PulseReportSwitch: false,
			spo2PulseModuleConfig: [],
			spo2PulseSecondaryTitle: "",
			sleepStructureSecondaryTitle: "",
			hrvReport: false,
			hrvModuleConfig: [],
			hrOnlyModuleConfig: [],
			hrvSubTitle: "",
			opinionNormal: "",
			opinionMild: "",
			opinionModerate: "",
			opinionSevere: "",
			localNewReportEnabled: false,
			leaderInfo: undefined,
			isShowVerifyAlert: false,
			saveCount: 0,
		};
	},

	computed: {
		hospitalID() {
			return this.$store.state.selectedHospital.hospitalid;
		}
	},

	created() {
		this.initValue()
		this.localNewReportEnabled = this.newReportSwitchEnabled;
		this.getLeaderInfo();
	},
	watch: {
		// 响应props变化
		newReportSwitchEnabled(newVal) {
			this.localNewReportEnabled = newVal;
		},
		// 监听model变化，重新初始化数据
		model: {
			handler(newVal) {
				if (newVal) {
					this.initValue();
				}
			},
			deep: true
		},
		// 监听医院ID变化，重新获取管理员信息
		hospitalID(newVal, oldVal) {
			if (newVal !== oldVal) {
				console.log('医院ID变化，重新获取管理员信息:', oldVal, '->', newVal);
				this.getLeaderInfo();
			}
		},
		// 监听睡眠结构报告开关状态
		sleepStructureSwitch(newVal) {
			// 如果开关关闭，清空选择和二级标题
			if (!newVal) {
				this.sleepStructureModuleConfig = [];
				this.sleepStructureSecondaryTitle = "";
			}
			// 如果开关打开但没有选中任何项，默认选中"基本信息"
			else if (newVal && this.sleepStructureModuleConfig.length === 0) {
				this.sleepStructureModuleConfig = ["基本信息"];
			}
		},
		// 监听血氧脉率报告开关状态
		spo2PulseReportSwitch(newVal) {
			// 如果开关关闭，清空选择和二级标题
			if (!newVal) {
				this.spo2PulseModuleConfig = [];
				this.spo2PulseSecondaryTitle = "";
			}
			// 如果开关打开但没有选中任何项，默认选中"基本信息"
			else if (newVal && this.spo2PulseModuleConfig.length === 0) {
				this.spo2PulseModuleConfig = ["基本信息"];
			}
		}
	},

	mounted() {
		console.log('sleepStructureModuleConfig', this.sleepStructureModuleConfig)
	},

	methods: {
		onNewReportSwitchChange(value) {
			// 通知父组件开关状态变化
			this.$emit('onSwitchChange', value);
		},
		initValue() {
			if (this.model.sopReportSignDate == "1") {
				this.sopReportSignDate = true;
			} else {
				this.sopReportSignDate = false;
			}

			if (this.model.sopReportSign == null || this.model.sopReportSign == "") {
				this.sopReportSign = false;
				this.sopReportSignValue = "";
			} else {
				this.sopReportSign = true;
				this.sopReportSignValue = this.model.sopReportSign;
			}

			// 基本信息初始化
			this.reportTitle = this.model.sopReportHeaders || "";
			this.reportSubTitle = this.model.sopReportSubTitle || "";
			this.reportLogo = this.model.sopReportLogo || "";
			

			// 报告组成初始化
			this.sleepStructureSwitch = !!this.model.sleepStructureSwitch;
			// 解析字符串为数组，如果解析失败或为空则使用默认值
			try {
				let parsedConfig = typeof this.model.sleepStructureModuleConfig === 'string' 
					? JSON.parse(this.model.sleepStructureModuleConfig) 
					: this.model.sleepStructureModuleConfig;
				this.sleepStructureModuleConfig = Array.isArray(parsedConfig) && parsedConfig.length > 0
					? parsedConfig
					: this.model.sleepStructureSwitch ? ["基本信息"] : [];
			} catch (e) {
				this.sleepStructureModuleConfig = this.model.sleepStructureSwitch ? ["基本信息"] : [];
			}
			this.sleepStructureSecondaryTitle = this.model.sleepStructureSecondaryTitle || "";

			this.spo2PulseReportSwitch = !!this.model.spo2PulseReportSwitch;
			// 解析字符串为数组，如果解析失败或为空则使用默认值
			try {
				let parsedConfig = typeof this.model.spo2PulseModuleConfig === 'string' 
					? JSON.parse(this.model.spo2PulseModuleConfig) 
					: this.model.spo2PulseModuleConfig;
				this.spo2PulseModuleConfig = Array.isArray(parsedConfig) && parsedConfig.length > 0
					? parsedConfig
					: this.model.spo2PulseReportSwitch ? ["基本信息"] : [];
			} catch (e) {
				this.spo2PulseModuleConfig = this.model.spo2PulseReportSwitch ? ["基本信息"] : [];
			}
			this.spo2PulseSecondaryTitle = this.model.spo2PulseSecondaryTitle || "";

			this.hrvReport = !!this.model.hrvReport;
			this.hrvModuleConfig = Array.isArray(this.model.hrvModuleConfig) ? this.model.hrvModuleConfig : [
				"基本信息", "心率", "HRV", "图表"
			];
			this.hrOnlyModuleConfig = Array.isArray(this.model.hrOnlyModuleConfig) ? this.model.hrOnlyModuleConfig : [
				"基本信息", "心率", "图表"
			];
			this.hrvSubTitle = this.model.hrvSubTitle || "";

			// 监测意见配置初始化
			this.opinionNormal = this.model.opinionNormal || "1.保持良好的生活习惯; 2.适当运动，增强体质;";
			this.opinionMild = this.model.opinionMild || "1.保持良好的生活习惯; 2.适当运动，增强体质;";
			this.opinionModerate = this.model.opinionModerate || "1.保持良好的生活习惯; 2.适当运动，增强体质;";
			this.opinionSevere = this.model.opinionSevere || "1.保持良好的生活习惯; 2.适当运动，增强体质;";
		},
		onCancelClick() {
			this.$emit("onCancelClick");
		},
		onSaveClick() {
			let signValue = ""

			if (this.sopReportSign == true) {
				signValue = this.sopReportSignValue
			}
			if (this.sopReportSign && signValue == "") {
				this.$toast.showRed('签名不能为空');
				return
			}
			
			// 新版报告配置校验
			if (this.newReportSwitchEnabled) {
				// 血氧脉率报告和睡眠结构报告必须至少选择一个
				if (!this.spo2PulseReportSwitch && !this.sleepStructureSwitch) {
					this.$toast.showRed(`请至少选择血氧脉率报告或睡眠结构报告中的一项`);
					return;
				}
				
				// 如果开启了血氧脉率报告，必须选择至少一个模块
				if (this.spo2PulseReportSwitch && this.spo2PulseModuleConfig.length === 0) {
					this.$toast.showRed('血氧脉率报告请至少选择一个模块');
					return;
				}
				
				// 如果开启了睡眠结构报告，必须选择至少一个模块
				if (this.sleepStructureSwitch && this.sleepStructureModuleConfig.length === 0) {
					this.$toast.showRed('睡眠结构报告请至少选择一个模块');
					return;
				}
			}
			
			// 验证管理员信息
			if (this.leaderInfo) {
				this.isShowVerifyAlert = true;
			} else {
				this.$toast.showRed("没有可用的管理员，请联系客服")
			}
		},
		onReportLogoUploadSucceed(iconURL) {
			this.reportLogo = iconURL;
		},
		async getLeaderInfo() {
			try {
				const params = {
					"hospitalId": this.hospitalID
				};
				const data = await this.$api.getLeaderInfo(params);
				this.leaderInfo = data
			} catch (error) {
				this.leaderInfo = undefined
				console.error('获取管理员信息失败:', error);
			}
		},
		onAlertConfirmClick(code) {
			this.isShowVerifyAlert = false;
			this.verifyRequest(code);
		},
		onAlertCancelClick() {
			this.isShowVerifyAlert = false;
		},
		async verifyRequest(code) {
			try {
				if (this.$store.state.accountInfo.roleName != '高级系统管理员') { 
					// 非高级系统管理员需要验证短信验证码
					const params = {
						"phone": this.leaderInfo.mobile,
						"verificationCode": code
					};
					await this.$api.smsVerification(params);
				}
				// 验证通过后执行保存
				this.doSave();
				// 增加保存计数并触发事件
				this.saveCount += 1;
				this.$emit("saveInfo", this.saveCount);
			} catch (error) {
				this.$toast.showRed(error);
			}
		},
		doSave() {
			let signValue = ""

			if (this.sopReportSign == true) {
				signValue = this.sopReportSignValue
			}
			
			const settingInfoModel = {
				sopReportHeaders: this.reportTitle,
				sopReportSign: signValue,
				sopReportSignDate: this.sopReportSignDate ? "1" : "0",
				sopReportSubTitle: this.reportSubTitle,
				sopReportLogo: this.reportLogo,
				isNewReport: this.isNewReport,
				sleepStructureSwitch: this.sleepStructureSwitch,
				sleepStructureModuleConfig: this.sleepStructureModuleConfig,
				sleepStructureSecondaryTitle: this.sleepStructureSecondaryTitle,
				spo2PulseReportSwitch: this.spo2PulseReportSwitch,
				spo2PulseModuleConfig: this.spo2PulseModuleConfig,
				spo2PulseSecondaryTitle: this.spo2PulseSecondaryTitle,
				hrvReport: this.hrvReport,
				hrvModuleConfig: this.hrvModuleConfig,
				hrOnlyModuleConfig: this.hrOnlyModuleConfig,
				hrvSubTitle: this.hrvSubTitle,
				opinionNormal: this.opinionNormal,
				opinionMild: this.opinionMild,
				opinionModerate: this.opinionModerate,
				opinionSevere: this.opinionSevere,
			};
			this.$emit("onSaveClick", settingInfoModel);
		},
	},


};
</script>

<style lang="scss" scoped>
.edit-root {
	display: flex;
	flex-direction: column;
	// gap: 32px;
	// padding: 32px 0;
	// background: #f5f7fa;
	// min-height: 100vh;
}

.edit-panel {
	background: #fff;
	border-radius: 8px;
	padding: 24px 24px 0 24px;
	display: flex;
	flex-direction: column;
	min-width: 320px;
	flex: 1;

	// box-shadow: 0 2px 8px rgba(0,0,0,0.03);
	&.left-panel {
		max-width: 320px;
		min-width: 300px;
	}

	&.middle-panel {
		flex: 1;
	}

	&.right-panel {
		min-width: 350px;
	}
}

.panel-title {
	font-size: 16px;
	font-weight: bold;
	color: #222;
	margin-bottom: 18px;
}

.signature-title {
	margin-top: 32px;
}

.panel-row {
	display: flex;
	align-items: center;
	/* 默认垂直居中 */
	margin-bottom: 18px;
	flex-wrap: wrap;

	// Checkbox组的样式
	.el-checkbox-group {
		display: flex;
		flex-wrap: wrap;

		.el-checkbox {
			margin-right: 16px;
			margin-bottom: 8px;
			font-size: 14px;
		}
	}
}

/* 特殊处理包含checkbox组的行 */
.checkbox-row {
	align-items: flex-start;

	.panel-label {
		margin-top: 0;
	}
}

.checkbox-container {
	display: flex;
	flex-wrap: wrap;
	flex: 1;

	.el-checkbox-group {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin-top: 4px;

		.el-checkbox {
			margin-bottom: 12px;
		}

		.el-checkbox:first-child {
			margin-left: 0;
		}
	}
}

/* 特殊处理包含textarea的行 */
.textarea-row {
	align-items: flex-start;
}

.panel-label {
	// width: 110px;
	color: #333;
	font-size: 14px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	min-height: 32px;
}

/* 特殊处理包含textarea的行中的label */
.textarea-row .panel-label {
	margin-top: 5px;
}

.panel-input {
	width: 230px;
}

.panel-logo-upload {
	margin-left: 0;
}

.panel-textarea {
	flex: 1;

	.el-textarea__inner {
		min-height: 60px !important;
	}
}

.signature-input {
	margin-left: 12px;
	width: 180px;
}

.btn-container {
	display: flex;
	justify-content: center;
	margin-top: 32px;
	margin-bottom: 24px;
	width: 100%;
}

.btn-cancel {
	color: #325FAC;
	font-size: 16px;
	border: 1px solid #325FAC;
	border-radius: 4px;
	width: 100px;
	height: 40px;
	background: #fff;
	margin-right: 24px;
	cursor: pointer;
}

.btn-save {
	color: #fff;
	background: #325FAC;
	font-size: 16px;
	border: 1px solid #325FAC;
	border-radius: 4px;
	width: 100px;
	height: 40px;
	cursor: pointer;
}

// 监测意见配置样式
.opinion-item {
	margin-bottom: 24px;
}

.opinion-label {
	font-size: 14px;
	color: #333;
	margin-bottom: 8px;
}

.opinion-textarea {
	width: 100%;

	.el-textarea__inner {
		min-height: 60px !important;
	}
}

// 签字与日期样式
.sign-item {
	display: flex;
	align-items: center;
	margin-bottom: 24px;
}

.sign-label {
	width: 110px;
	font-size: 14px;
	color: #333;
	flex-shrink: 0;
}

.sign-control {
	display: flex;
	align-items: center;
	flex: 1;
}

.sign-input {
	width: 220px;
	margin-left: 12px;
}

// 按钮区域样式
.action-buttons {
	display: flex;
	justify-content: center;
	margin-top: 32px;
	margin-bottom: 24px;
}
</style>